<template>
	<div class="product-list" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
		<div class="product-list-header">
			<div class="header-icon"></div>
			<span class="header-title" v-if="editablePageConfig.editable_page_config_content.text[0].list[0]">{{ editablePageConfig.editable_page_config_content.text[0].list[0].content }}</span>
			<span class="iconfont"></span>
		</div>
		<div class="product-list-body">
			<div
					v-for="(item, index) in editablePageConfig.goods_list[0]"
					v-bind:key="index"
					class="product-info"
					v-bind:class="{ border: index % 2 == 0 }"
					@click="productClick(item.goods_id)"
			>
				<img class="product-icon" v-lazy="item.goods_image_url"/>
				<span class="product-title">{{ item.goods_name }}</span>
				<div class="product-bottom">
					<span class="product-price">￥{{ item.goods_promotion_price }}</span>
					<span class="product-buy">{{ item.goods_salenum }}人已购买</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
  name: 'Model6',
  data () {
    return {
      scroll: null
    }
  },
  props: ['editablePageConfig'],
  components: {},
  computed: {},
  watch: {

  },

  mounted () {
    // let isScrollParam = JSON.parse(localStorage.getItem('listParams'))

    // window.onscroll = function () {
    //   // 为了保证兼容性，这里取三个值，哪个有值取哪一个
    //   // scrollTop就是触发滚轮事件时滚轮的高度
    //   this.scroll = document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset
    //   // console.log(isScrollParam, '12333')
    //   // console.log('滚动距离' + this.scroll)
    //
    //   if (this.scroll > 1) {
    //     // 清除缓存
    //     localStorage.removeItem('listParams')
    //   }else {
    //     // 获取元素在页面中的位置
    //     var listParam = {
    //       // 滚动条位置
    //       scroll: this.scroll
    //     }
    //     localStorage.setItem('listParam', JSON.stringify(listParam))
    //     document.documentElement.scrollTop = listParam.scroll // pc的移动端调试模式管用，真机上不行
    //     document.body.scrollTop = listParam.scroll// 真机用这个！！！
    //   }
    // }
  },
  methods: {
    productClick (goods_id) {
      // 清除缓存
      localStorage.removeItem('listParam')
      localStorage.removeItem('classifyScrollList')
      // 获取元素在页面中的位置
      this.scroll = document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset
      var listParams = {
        // 滚动条位置
        scroll: this.scroll
      }
      localStorage.setItem('listParams', JSON.stringify(listParams))
      // console.log(JSON.parse(localStorage.getItem('listParams')), 'scrollscrollscroll')

      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
      // // 清除缓存
      // localStorage.removeItem('listParam')
    }
  },
  created () {
    console.log(this.$route.name, '111--------errrrrrrrrr')
    // if (this.$route.name == 'HomeSpecial'){
    //
    // }+
    let scrollParam = JSON.parse(localStorage.getItem('listParams'))
    console.log(scrollParam, '是否缓存了高------mmm666')
    if (scrollParam) {
      document.documentElement.scrollTop = scrollParam.scroll // pc的移动端调试模式管用，真机上不行
      document.body.scrollTop = scrollParam.scroll// 真机用这个！！！
      console.log(document.body.scrollTop, document.documentElement.scrollTop, window.pageXOffset, '赋高度值-------------的的的的位置')
    } else {
      // 清除缓存
      localStorage.removeItem('listParams')
    }
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.product-list {
	background: #ffffff;
	margin-top:0.6rem;
	margin-bottom:0.6rem;
	.product-list-header {
		background: #fff;
		display: flex;
		height:2rem;
		padding: 0 0.25rem;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #f5f5f5;
		.header-title {
			font-size:0.7rem;
			color: #333;
			font-weight:700;
		}
		.header-icon {
			width:1rem;
			height:1rem;
		}
	}
	.product-list-body {
		background: #fff;
		display: flex;
		flex-wrap: wrap;
	}
}
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding:0.5rem;
	justify-content: flex-end;
	border-bottom: 1px solid #f5f5f5;
	width:50%;box-sizing:border-box;
	.product-icon {
		align-self: center;
		width:100%;box-sizing:border-box;
	}
	.product-title {
		color: #333;
		font-size: .6rem;
		margin-top: 1rem;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
	.product-bottom {
		display: flex;
		justify-content: space-between;
		margin-top:.4rem;
		line-height:1rem;
		.product-price {
			color: $primaryColor;
			font-size:.7rem;
		}
		.product-buy {
			color: #999999;
			font-size:.65rem;
		}
	}
}
</style>
